import React, { Component } from 'react';
import { Route } from 'react-router-dom';
// Components
import Login from '../Pages/Login';
import ListEvents from '../Pages/ListEvents';
import EventDetails from '../Pages/EventDetails';
import Checkout from '../Pages/Checkout';
import Thanks from '../Pages/ThankYou';
import Declined from '../Pages/Declined';
import Politics from '../Pages/Politics';
import Footer from './Footer';

import { connect } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import Devolution from '../Pages/Politics/Devolution';
import Transmition from '../Pages/Politics/Transmition';

const getState = (state) => {
    return {
        login: state.login
    }
}
class Content extends Component {
    render() {
        return (
            <BrowserRouter>
            <div className="content">
                {!this.props.login ?
                    <Login />
                    :
                    <div>
                        <Route path='/' exact component={ListEvents} />
                        <Route path='/profile' exact component={ListEvents} />
                        <Route path='/politica-privacidad' exact component={Politics} />
                        <Route path='/politica-devolucion' exact component={Devolution} />
                        <Route path='/politica-transmision' exact component={Transmition} />
                        <Route path='/detail' component={EventDetails} />
                        <Route path='/tickets' exact component={ListEvents} />
                        <Route path='/checkout' exact component={Checkout} />
                        <Route path='/thanks' exact component={Thanks} />
                        <Route path='/declined' exact component={Declined} />
                    </div>
                }
                <Footer/>
            </div>
            </BrowserRouter>
        );
    }
}

export default connect(getState, null)(Content);



// WEBPACK FOOTER //
// ./src/Layouts/content.js